export default __webpack_public_path__ + "chain8e7a53.png";